module.exports = __webpack_public_path__ + "img/banner-7.6ed71b6d.png";